import { render } from "./CyanicAssistantChat.vue?vue&type=template&id=68c0985c&scoped=true"
import script from "./CyanicAssistantChat.vue?vue&type=script&lang=js"
export * from "./CyanicAssistantChat.vue?vue&type=script&lang=js"

import "./CyanicAssistantChat.vue?vue&type=style&index=0&id=68c0985c&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c0985c"]])

export default __exports__